const enabled = !!AFRAME.utils.getUrlParameter('headfist');

AFRAME.registerComponent('headfist', {
  schema: {
    hand: {type: 'string'},
    isPlaying: {default: false}
  },

  init: function () {
    console.log(`[headfist] ${enabled}`);
    if (!enabled) { return; }
    this.camera = document.getElementById('camera').object3D;
    this.originalParent = this.el.object3D.parent;
  },

  update: function () {
    const el = this.el;

    if (!enabled || !this.camera) { return; }

    // Attach hands to head.
    if (this.data.isPlaying) {
      this.camera.add(el.object3D);

      el.object3D.rotation.set(-5, 0, 0);
      el.object3D.position.set(
        this.data.hand === 'right' ? 0.175 : -0.175,
        0.15,
        -0.2
      );

      el.components['tracked-controls'].pause();
      if (el.components['tracked-controls-webvr']) {
        el.components['tracked-controls-webvr'].pause();
      }
      if (el.components['tracked-controls-webxr']) {
        el.components['tracked-controls-webxr'].pause();
      }
      return;
    }

    // Add hands back.
    if (el.object3D.parent !== this.originalParent) {
      console.log(`[headfist] Detach.`);
      this.originalParent.add(el.object3D);
      if (el.components['tracked-controls-webvr']) {
        el.components['tracked-controls-webvr'].play();
      }
      if (el.components['tracked-controls-webxr']) {
        el.components['tracked-controls-webxr'].play();
      }
    }
  }
});
if (module.hot && window.AFRAME) {
  const componentNames = ['headfist',];

  const shaderNames = [];

  const systemNames = [];

  // Clean up from application when module is unloaded.
  module.hot.dispose(data => {
    let els;
    data.needsReplace = true;

    componentNames.forEach(component => {
      // Unregister.
      delete AFRAME.components[component];
      const els = AFRAME.scenes[0].querySelectorAll(`[${component}]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        els[i].setAttribute(`data-__hot-${component}`,
                            JSON.stringify(els[i].getDOMAttribute(component)));
        // Detach component.
        els[i].removeAttribute(component);
      }
    });

    shaderNames.forEach(shader => {
      // Unregister.
      delete AFRAME.shaders[shader];
      const els = AFRAME.scenes[0].querySelectorAll(`[material]`);
      for (let i = 0; i < els.length; i++) {
        if (!els[i].isEntity) { continue; }
        // Store data.
        if (els[i].getAttribute('material').shader !== shader) { continue; }
        els[i].setAttribute('data-__hot-material', JSON.stringify(
          els[i].getDOMAttribute('material')));
        // Detach material.
        els[i].removeAttribute('material');
      }
    });

    systemNames.forEach(system=> {
      delete AFRAME.systems[system];
      delete AFRAME.scenes[0].systems[system];
    });
  });

  if (module.hot.data && module.hot.data.needsReplace) {
    // Apply component back to entities.
    componentNames.forEach(componentName => {
      const dataAttrName = `data-__hot-${componentName}`;
      const els = document.querySelectorAll(`[${dataAttrName}]`);
      for (let i = 0; i < els.length; i++) {
        els[i].setAttribute(componentName, JSON.parse(els[i].getAttribute(dataAttrName)), true);
        els[i].removeAttribute(dataAttrName);
      }
    });

    // Apply materials back.
    const dataAttrName = 'data-__hot-material';
    const els = document.querySelectorAll(`[${dataAttrName}]`);
    for (let i = 0; i < els.length; i++) {
      els[i].setAttribute('material', JSON.parse(els[i].getAttribute(dataAttrName)), true);
      els[i].removeAttribute(dataAttrName);
    }
  }

  module.hot.accept();
}
